import React, { useEffect, useState } from "react";
import images from "../../assets/images";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ROUTES } from "../../constants/routes.constants";
import userService from "../../services/user.service";
import { useDispatch } from "react-redux";
import { userSlice } from "../../redux/slices/user.slice";
import http from "../../utility/http";
import "./index.scss";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [buttonAnimation, setButtonAnimation] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();

    // If password is not shown yet, check username and decide next step
    if (!showPassword) {
      if (username && username.includes('@walgreens.com')) {
        // Redirect to SSO for Wallgreens users
        window.location.href = "https://sso.transfermyrx.com/oauth/authorize?client_id=WvgNZjFhKBvfhpHCTNzgd&redirect_uri=https://portal.transfermyrx.com/login&response_type=code&email=" + username;
        return;
      } else if (username) {
        // Show password field for non-Wallgreens users
        setButtonAnimation('animate__pulse');
        setTimeout(() => {
          setShowPassword(true);
          setButtonAnimation('');
        }, 300);
        return;
      }
    }

    if (username.length === 0) {
      return;
    }

    // Proceed with normal login if password is shown
    setIsLoading(true);
    try {
      const loginResult = await userService.Login(username, password);
      if (loginResult.error === null) {
        dispatch(userSlice.actions.login(loginResult.data));
        const userData = loginResult.data?.user;
        if (
          (userData.roleId === 2 ||
            userData.roleId === 3 ||
            userData.roleId === 4) &&
          !userData.pharmacyBranchId
        ) {
          navigate(ROUTES.CHOOSE_PHARMACY_ACCOUNT_ROUTE);
        } else {
          if (userData.roleId === 7) {
            navigate(ROUTES.TRANSFER_IN_REQUEST_ROUTE);
          } else {
            navigate(ROUTES.DASHBOARD_ROUTE);
          }
        }
      } else {
        //Focus on field username
      }
    } catch (error) {
      console.error('Login error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const LoginCode = async (code) => {
    setIsLoading(true);
    try {
      const loginResult = await http.post("/v1/user/sso/auth", {
        email: code,
        code
      });
      console.log(loginResult);
      if (loginResult.error === null) {
        dispatch(userSlice.actions.login(loginResult.data));
        const userData = loginResult.data?.user;
        if (
          (userData.roleId === 2 ||
            userData.roleId === 3 ||
            userData.roleId === 4) &&
          !userData.pharmacyBranchId
        ) {
          navigate(ROUTES.CHOOSE_PHARMACY_ACCOUNT_ROUTE);
        } else {
          if (userData.roleId === 7) {
            navigate(ROUTES.TRANSFER_IN_REQUEST_ROUTE);
          } else {
            navigate(ROUTES.DASHBOARD_ROUTE);
          }
        }
      } else {
        //Focus on field username
      }
    } catch (error) {
      console.error('Login code error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    document.title = "TransferMyRx::Login";

    // Check for code parameter in URL
    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get('code');
    console.log(code);
    if (code) {
      LoginCode(code);
    }
  }, [location.search]);


  return (
    <>
      {isLoading && (
        <div className={isLoading ? 'card w-100 h-100 d-flex justify-content-center align-items-center position-absolute bg-transparent loading-container' : 'd-none'}>
          <div className="w-100 h-100 position-absolute bg-white opacity-75"></div>
          <div
            className={`d-flex justify-content-flex-start align-items-center position-absolute p-3
               border border-dark shadow-lg rounded-1 loading animate__animated animate__faster
               animate__zoomIn`}
          >
            <div className="spinner-border text-success me-3"></div>
            <span className="">Processing...</span>
          </div>
        </div>
      )}
      <div
        id="login-form"
        className="auth-form p-4 p-sm-5 shadow-lg rounded-1 border-primary bg-white animate__animated"
      >
        <div className="text-center mb-3">
          <a href="https://www.TransferMyRx.com">
            <img src={images.Logo} alt="TransferMyRx" className="img-fluid" />
          </a>
        </div>
        <h5 className="text-center mb-4">Log in to your account</h5>

        {/* Step Indicator */}
        <div className="form-step-indicator">
          <div className={`step-dot ${!showPassword ? 'active' : ''}`}></div>
          <div className={`step-dot ${showPassword ? 'active' : ''}`}></div>
        </div>

        <form onSubmit={(event) => handleSubmit(event)} className="form-container">
          <div className="col-12 mb-3">
            <label htmlFor="username" className="form-label">
              User Name
            </label>
            <input
              id="username"
              type="text"
              className={`form-control username-field ${showPassword ? 'disabled' : ''}`}
              placeholder="User Name"
              value={username || ''}
              onChange={(event) => setUsername(event.target.value)}
              disabled={showPassword}
            />
          </div>

          {showPassword && (
            <div className="col-12 mb-3 password-field-enter animate__animated animate__fadeInDown">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <input
                id="password"
                type="password"
                className="form-control"
                placeholder="Password"
                autoFocus
                onChange={(event) => setPassword(event.target.value)}
              />
            </div>
          )}
          {showPassword && (
            <div className="form-row d-flex justify-content-between mt-4 mb-2 ">
              <div className="mb-3">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="remember-me-cb"
                  />
                  <label className="form-check-label" htmlFor="remember-me-cb">
                    Remember me
                  </label>
                </div>
              </div>
              <div className="mb-3">
                <Link to={ROUTES.FORGOTPASSWORD_ROUTE} className="link-default">
                  Forgot Password?
                </Link>
              </div>
            </div>
          )}
          {showPassword && (
            <button
              type="button"
              className="w-100 btn btn-outline-secondary btn-lg mb-2  "
              onClick={() => {
                setButtonAnimation('animate__fadeOut');
                setTimeout(() => {
                  setShowPassword(false);
                  setPassword('');
                  setButtonAnimation('');
                }, 200);
              }}
            >
              Back
            </button>
          )}
          <button
            type="submit"
            className={`w-100 mb-2 btn btn-default btn-lg next-button-transform animate__animated ${buttonAnimation}`}
            key={showPassword ? 'login' : 'next'}
          >
            {showPassword ? 'Log In' : 'Next'}
          </button>
          {/* <button  className="w-100 btn btn-default btn-lg mt-2 " onClick={(event) => {
            event.preventDefault();
            window.location.href = "https://sso.transfermyrx.com/oauth/authorize?client_id=WvgNZjFhKBvfhpHCTNzgd&redirect_uri=https://pharmacy.transfermyrx.com/login&response_type=code";
          }}>
            Log In Using SSO
          </button> */}
          <div className="mt-[20px]">
            By clicking Log In, you have read and agree to the&nbsp;
            <a
              className="link-default"
              href="https://www.transfermyrx.com/#/terms-and-conditions"
              target="_blank"
            >
              Terms and Conditions
            </a>
            &nbsp;and&nbsp;
            <a
              className="link-default"
              href="https://www.transfermyrx.com/#/privacy-policy"
              target="_blank"
            >
              Privacy Policy
            </a>
            .
          </div>
        </form>
        <div className="mt-3 text-start ">
          Do you have a login code?&nbsp;
          <Link className="link-default" to={ROUTES.LOGIN_WITH_CODE_ROUTE}>
            Log In With Code
          </Link>
        </div>

        <div className="mt-3 text-start ">
          Don't have an account?&nbsp;
          <Link className="link-default" to={ROUTES.SIGNUP_ROUTE}>
            Sign Up
          </Link>
        </div>
      </div>
    </>
  );
};
export default Login;
